<template>
  <div class='relative top-section'
       :style="[windowWidth <= PHONE ? `height: 225px; background-image: url('${props.topInfo.bg}')` : ' padding: 10px 20px 0;']">
    <div :class="['py-12 tl-px-40 mb-px-20 wp-100 hp-100 flex items-end', ((windowWidth <= PHONE) && !globalEnquiry ) ? 'white bg-linear-gradient': '']">
      <div>
        <div :class="['fw-700 pb-4 fs-36 lh-48 tl-fs-28 tl-fs-42 mb-fs-24 mb-lh-32']" v-html='props.topInfo?.title'></div>
        <div v-if='props.topInfo.trip_name' class='fs-16 fw-500 lh-24 pb-4'>{{props.topInfo?.trip_name}}</div>
        <Rating v-if='customersText' :percent='props.topInfo?.rating'></Rating>
        <span v-if='customersText' class='fs-14 fw-600 lh-20'>&nbsp;by {{customersText}} happy customers</span>
      </div>
    </div>
  </div>
</template>

<script setup>
  import {computed} from 'vue'
  import {PHONE} from '~/constant/common'
  import {useRoute} from 'vue-router'
  import Rating from '~/components/pages/Enquiry/Sections/Rating.vue'
    import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

  const route = useRoute()

  const props = defineProps({
    topInfo: { type: Object, default: () => {}}
  })

  const generalStore = useGeneralInfoStore()

  const windowWidth = computed(() => generalStore.generalData.windowWidth)

  const customersText = computed(() => {
    return route.name === 'enquiry-submit-ld' ? props.topInfo.customers : '1,900+'
  })

  const globalEnquiry = computed(() => {
    return route.name === 'enquiry-submit-global'
  })

</script>

<style scoped lang="scss">
  .top-section {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
</style>
